import { useCallback, useMemo } from "react"
import useUser from "../../user/hooks/use-user";

export default function useGtagEvents() {
    const { user, libraryCode } = useUser();

    const userParams = useMemo(() => {
        return {
            complete_task_count: user?.completedTasks.length,
            library_code: libraryCode
        }
    }, [user, libraryCode]);

    const sendTaskCompleted = useCallback((taskId: string) => {
        try {
            gtag('event', 'complete_task', {
                event_category: 'task',
                event_label: 'Zadanie wykonane',
                task_id: taskId,
                ...userParams
            });
        } catch (e) { }
    }, [userParams]);

    const sendGameCompleted = useCallback(() => {
        try {
            gtag('event', 'complete_game', {
                event_category: 'task',
                event_label: 'Gra ukończona',
                ...userParams
            });
        } catch (e) { }
    }, [userParams]);

    const sendRestartGame = useCallback(() => {
        try {
            gtag('event', 'restart_game', {
                event_category: 'task',
                event_label: 'Gra zrestartowana',
                ...userParams
            });
        } catch (e) { }
    }, [userParams]);

    return {
        sendTaskCompleted,
        sendGameCompleted,
        sendRestartGame
    }
}
